<template>
  <div id="sidebar-layout">
    <div class="nav">
      <aside>
        <p class="has-text-centered cube">
          CUBE
        </p>
        <component
          :is="sidebar"
          id="sidebar"
        />
      </aside>
    </div>
    <main id="content">
      <section class="section">
        <div class="container">
          <slot />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import {SideBar} from "../components/";

  export default {
    name: 'SidebarLayout',
    computed: {
      sidebar() {
        return SideBar
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles";
  @import url('https://fonts.googleapis.com/css?family=Quicksand&display=swap');

  $sidebar-width: 300px;

  #sidebar-layout {
    display: grid;
    grid-template-areas: "a b";
    grid-template-columns: $sidebar-width 1fr;
    height: 100vh;
  }

  #sidebar {
    width: $sidebar-width;
    padding: 0rem 1rem 0 1rem;
  }

  .nav {
    grid-area: a;
    background: linear-gradient(135deg, rgba(99, 99, 99, 0.52) 0%, rgba(99, 99, 99, 0.52) 12.5%, rgba(94, 94, 94, 0.52) 12.5%, rgba(94, 94, 94, 0.52) 25%, rgba(89, 89, 89, 0.52) 25%, rgba(89, 89, 89, 0.52) 37.5%, rgba(84, 84, 84, 0.52) 37.5%, rgba(84, 84, 84, 0.52) 50%, rgba(79, 79, 79, 0.52) 50%, rgba(79, 79, 79, 0.52) 62.5%, rgba(74, 74, 74, 0.52) 62.5%, rgba(74, 74, 74, 0.52) 75%, rgba(69, 69, 69, 0.52) 75%, rgba(69, 69, 69, 0.52) 87.5%, rgba(64, 64, 64, 0.52) 87.5%, rgba(64, 64, 64, 0.52) 100%), linear-gradient(90deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 12.5%, rgb(3, 3, 3) 12.5%, rgb(3, 3, 3) 25%, rgb(7, 7, 7) 25%, rgb(7, 7, 7) 37.5%, rgb(10, 10, 10) 37.5%, rgb(10, 10, 10) 50%, rgb(13, 13, 13) 50%, rgb(13, 13, 13) 62.5%, rgb(16, 16, 16) 62.5%, rgb(16, 16, 16) 75%, rgb(20, 20, 20) 75%, rgb(20, 20, 20) 87.5%, rgb(23, 23, 23) 87.5%, rgb(23, 23, 23) 100%);
    min-height: 100vh;
    width: 300px;
    overflow-y: auto;
  }

  #content {
    grid-area: b;
    overflow-y: auto;
  }

  .cube {
    color: nth(map_get($colors, 'brand'), 2);
    font-family: 'Quicksand', sans-serif;
    font-size: 3.25rem;
    margin-top: 1rem;
  }
</style>
